import useQuasar from 'quasar/src/composables/use-quasar.js';
import i18n from '@/plugins/i18n'
import { initPortalStoreAsync } from '@/stores/portal.store'

const tSafe = (key, fallback) => {
  const { t, te } = i18n.global
  return te(key) ? t(key) : fallback
}

export function useInitPortalStore(isAuthenticated = false) {
  const $q = useQuasar()

  const tryInitPortalStoreAsync = async() => {
    try {
      await initPortalStoreAsync(isAuthenticated)
    } catch (e) {
      showInitErrorDialog()
    }
  }

  const showInitErrorDialog = () => {
    $q.dialog({
      title: tSafe('error.generic', 'Error'),
      message: tSafe('error.initPortalStore', 'An error occurred while loading the application. Please try again.'),
      persistent: true,
      ok: { label: tSafe('common.retry', 'Retry'), color: 'primary' },
      cancel: { label: tSafe('common.exit', 'Exit'), flat: true, color: 'negative' },
    }).onOk(() => {
      tryInitPortalStoreAsync()
    }).onCancel(() => {
      window.location.href = window.config.AUTH_SERVER_URL
    })
  }

  return { tryInitPortalStoreAsync }
}
